<div class="nav-bar">
  <div class="nav-panel">
    <div class="header-position">
      <ukg-label class="nav-bar-text" type="tertiary" translate data-automation="pay_info_selected_items_count"
        [translateParams]="{ selectedCount: selectedPayItemCount }">
        COMMON.SELECTED_ITEMS_COUNT
      </ukg-label>
    </div>
    <div class="header-position">
      <div>
        <ukg-button type="text" (click)="exportSelectedPays()" data-automation="pay_info_export_btn"
          [attr.aria-disabled]="!areAnyPaysSelected() || isWorking" [disabled]="!areAnyPaysSelected() || isWorking"
          translate emphasis="mid" size="medium"> COMMON.BUTTON_EXPORT
        </ukg-button>
      </div>
    </div>
    <div class="header-position">
      <div>
        <ukg-popover #cancelTooltip type="standard">
          <p [innerHtml]="'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUCCESSFUL_DETAILS' | translate"></p>
          <ukg-list>
            <ukg-list-item>
              <p [innerHtml]="'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUCCESSFUL_CHECK_DETAILS' | translate"></p>
            </ukg-list-item>
            <ukg-list-item>
              <p [innerHtml]="'EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_SUCCESSFUL_DD_TOOLTIP_DETAILS' | translate"></p>
            </ukg-list-item> 
          </ukg-list>
        </ukg-popover>
        <ukg-icon name="help" (click)="cancelTooltip.present($event.target)" placement="bottom right" data-automation="cancel_tooltip">
        </ukg-icon>
      </div>
    </div>
    <div class="header-position">
      <div class="stop-payment-btn">
        <ukg-button type="text" (click)="stopPayment()" data-automation="pay_info_stop_payment_btn"
          *ngIf='showStopPaymentButton' [attr.aria-disabled]="disableStopPaymentButtons() || isWorking"
          [disabled]="disableStopPaymentButtons() || isWorking" translate emphasis="mid" size="medium">
          EMPLOYEE_PAYS.STOP_PAYMENT
          <small class="btn-text" data-automation="pay_info_stop_payment_btn_max" translate
            [translateParams]="{maxRecords : maxStoppableRecords}">
            EMPLOYEE_PAYS.PAY_ITEMS_MAXIMUM
          </small>
        </ukg-button>
      </div>
    </div>
    <div class="header-position">
      <div class="cancel-stop-payment-btn">
        <ukg-button type="text" (click)="cancelStopPayment()" data-automation="pay_info_cancel_stop_payment_btn"
          *ngIf='showCancelStopPaymentButton' [attr.aria-disabled]="disableStopPaymentButtons() || isWorking"
          [disabled]="disableStopPaymentButtons() || isWorking" translate emphasis="mid" size="medium">
          EMPLOYEE_PAYS.CANCEL_STOP_PAYMENT <small class="btn-text" data-automation="pay_info_cancel_stop_payment_btn_max" translate
            [translateParams]="{maxRecords : maxStoppableRecords}">EMPLOYEE_PAYS.PAY_ITEMS_MAXIMUM</small>
        </ukg-button>
      </div>
    </div>
  </div>
  <div>
    <div class="header-position">
      <div class="filter-position">
        <ssg-pay-info-filters (toggle)="showFilters=$event" style="height: 100%"
          class="flex-1-0-auto" [isWorking]="isWorking">
        </ssg-pay-info-filters>
      </div>
    </div>
  </div>
</div>

<div class="display-notification">
  <ssg-notification-bar [userMessages]="userMessages" [notification]="notificationSubject.asObservable()"
    pageKey="pay-info-table" #payInfoTableNotificationBar>
  </ssg-notification-bar>
</div>

<div style="position: relative;" class="datatable-position">
  <div [ngClass]="{'table-with-filters-container-on': showFilters, 'table-with-filters-container-off': !showFilters }">
    <div class="table-container flex-100">

      <ukg-data-table-container>
        <ukg-data-table [columnNames]="allColumns" (ukgDataTableSortChanged)="handleSort($event)"
          data-automation="pay-info-table">
          <table id="table">
            <thead id="head">
              <tr>
                <ng-container data-automation="pay-info-table-column-paySelected">
                  <ukg-th style="width:2%" data-automation="pay-info-table-header-paySelected">
                    <div class="checkbox">
                      <label for="select-all-pays" translate>
                        <input type="checkbox" id="select-all-pays"
                          data-automation="pay-info-table-header-paySelected-checkbox" [checked]="areAllPaysSelected()"
                          [indeterminate]="!areAllPaysSelected() && areAnyPaysSelected()"
                          (click)="clickAllPays($event.target.checked)" />
                      </label>
                    </div>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-displayName">
                  <ukg-th data-automation="pay-info-table-header-displayName" sort-key="displayName"
                    sortable>
                    <span data-automation="pay-info-table-header-displayName-label" translate>
                      EMPLOYEE_PAYS.COLUMN_NAME</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-employeeNumber">
                  <ukg-th style="width:10%" data-automation="pay-info-table-header-employeeNumber"
                    sort-key="pay.employee.employeeNumber" sortable>
                    <span data-automation="pay-info-table-header-employeeNumber-label" translate>
                      EMPLOYEE_PAYS.COLUMN_EMPLOYEE_NUMBER
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-payGroup">
                  <ukg-th style="width:8%" data-automation="pay-info-table-header-payGroup"
                    sort-key="pay.integration.payGroup" sortable>
                    <span data-automation="pay-info-table-header-payGroup-label"
                      translate>EMPLOYEE_PAYS.COLUMN_PAY_GROUP</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-payUtcDate">
                  <ukg-th style="width:8%" data-automation="pay-info-table-header-payUtcDate" sort-key="pay.payUtcDate"
                    sortable>
                    <span data-automation="pay-info-table-header-payUtcDate-label" translate>
                      EMPLOYEE_PAYS.COLUMN_PAY_DATE
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-netAmount">
                  <ukg-th style="width:9%" data-automation="pay-info-table-header-netAmount" sort-key="pay.netAmount"
                    sortable>
                    <span data-automation="pay-info-table-header-netAmount-label" translate>
                      EMPLOYEE_PAYS.COLUMN_NET_AMOUNT
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-payItemSelected-paymentType">
                  <ukg-th style="width:11%" data-automation="pay-info-table-header-payItemSelected-paymentType"
                    sort-key="payItem.paymentType" sortable>
                    <span data-automation="pay-info-table-header-paymentType-label" translate>
                      EMPLOYEE_PAYS.COLUMN_PAYMENT_TYPE
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-payItemAmount">
                  <ukg-th style="width:10%" data-automation="pay-info-table-header-payItemAmount"
                    sort-key="payItem.amount" sortable>
                    <span data-automation="pay-info-table-header-payItemAmount-label" translate>
                      EMPLOYEE_PAYS.COLUMN_ITEM_AMOUNT
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-payItemNumber">
                  <ukg-th style="width:12%" class="datatable-document-header" data-automation="pay-info-table-header-payItemNumber"
                    sort-key="payItem.itemNumber" sortable>
                    <span>
                      <span class="header-container" data-automation="pay-info-table-header-payItemNumber-label">
                        <span [innerHtml]="'EMPLOYEE_PAYS.COLUMN_ITEM_NUMBER' | translate">
                        </span>
                      </span>
                    </span>
                    <ukg-icon name="help" (click)="$event.stopPropagation(); itemNumberTooltip.present($event.target);"
                      data-automation="column_item_number_tooltip_icon">
                    </ukg-icon>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-statusText">
                  <ukg-th style="width:10%" data-automation="pay-info-table-header-statusText"
                    sort-key="statusText" sortable>
                    <span data-automation="pay-info-table-header-statusText-label" translate>
                      EMPLOYEE_PAYS.COLUMN_STATUS
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="pay-info-table-column-attachments">
                  <ukg-th style="width:35px" data-automation="pay-info-table-header-attachments"></ukg-th>
                </ng-container>
              </tr>
            </thead>
            <tbody data-automation="data-table-body">
              <ng-container *ngFor="let payItems of records; let i = index">
                <tr>
                  <td [ngClass]="{ subsequent: isSubsequentPayRow(payItems) }" class="check-cell"
                    data-automation="pay-info-table-row-paySelected">
                    <div class="checkbox" *ngIf="!isSubsequentPayRow(payItems)">
                      <label for="{{ 'select-pay-' + payItems.id }}" translate>
                        <input data-automation="pay-info-table-row-paySelected-checkbox" type="checkbox"
                          id="{{ 'select-pay-' + payItems.id }}" [checked]="isPaySelected(payItems)"
                          [indeterminate]="isPayPartiallySelected(payItems)"
                          (click)="clickPay(payItems, $event.target.checked)" />
                      </label>
                    </div>
                  </td>
                  <td [ngClass]="{ subsequent: isSubsequentPayRow(payItems) }"
                    data-automation="pay-info-table-row-displayName">
                    <span [hidden]="isSubsequentPayRow(payItems)" 
                      (mouseenter)="payItemDisplayName.present($event.target)"
                      (mouseleave)="payItemDisplayName.dismiss()"
                      data-automation="pay-info-table-row-displayName-content" >
                        {{payItems?.displayName | truncate:30}}
                    </span>
                    <ukg-popover #payItemDisplayName position="top">{{payItems.displayName}}</ukg-popover>
                  </td>
                  <td [ngClass]="{ subsequent: isSubsequentPayRow(payItems) }"
                    data-automation="pay-info-table-row-employeeNumber">
                    <span [hidden]="isSubsequentPayRow(payItems)" 
                      (mouseenter)="payItemEmployeeNumber.present($event.target)"
                      (mouseleave)="payItemEmployeeNumber.dismiss()"
                      data-automation="pay-info-table-row-employeeNumber-content">
                        {{payItems?.pay.employee.employeeNumber | truncate:20}}
                    </span>
                    <ukg-popover #payItemEmployeeNumber position="top">{{payItems.pay.employee.employeeNumber}}</ukg-popover>
                  </td>
                  <td [ngClass]="{ subsequent: isSubsequentPayRow(payItems) }"
                    data-automation="pay-info-table-row-payGroup">
                    <span [hidden]="isSubsequentPayRow(payItems)" 
                      (mouseenter)="payItemPayGroup.present($event.target)"
                      (mouseleave)="payItemPayGroup.dismiss()"
                        data-automation="pay-info-table-row-payGroup-content">
                      {{payItems?.pay.integration.payGroup | truncate:6}}
                    </span>
                    <ukg-popover #payItemPayGroup position="top">{{payItems.pay.integration.payGroup}}</ukg-popover>
                  </td>
                  <td [ngClass]="{ subsequent: isSubsequentPayRow(payItems) }"
                    data-automation="pay-info-table-row-payUtcDate">
                    <span data-automation="pay-info-table-row-payUtcDate-content"
                      [hidden]="isSubsequentPayRow(payItems)"
                      (mouseenter)="payItemPayDate.present($event.target)"
                      (mouseleave)="payItemPayDate.dismiss()">
                        {{payItems?.pay.payUtcDate | ultishortdate: 'L'}}
                    </span>
                    <ukg-popover #payItemPayDate position="top">{{payItems.pay.payUtcDate | ultishortdate: 'L'}}</ukg-popover>
                  </td>
                  <td [ngClass]="{ subsequent: isSubsequentPayRow(payItems) }"
                    data-automation="pay-info-table-row-netAmount">
                    <span data-automation="pay-info-table-row-netAmount-content" [hidden]="isSubsequentPayRow(payItems)"
                      (mouseenter)="payItemNetAmount.present($event.target)"
                      (mouseleave)="payItemNetAmount.dismiss()">
                        {{payItems?.pay.netAmount | ulticurrency:'1.02':undefined:true}}
                    </span>
                    <ukg-popover #payItemNetAmount position="top">{{payItems.pay.netAmount | ulticurrency:'1.02':undefined:true}}</ukg-popover>
                  </td>
                  <td class="check-cell" data-automation="pay-info-table-row-payItemSelected-paymentType">
                    <div class="checkbox">
                      <label for="{{ 'select-payItem-' + payItems.id }}" translate>
                        <input *ngIf="payHasMultipleItems(payItems.pay)" class="pay-item-selected-checkbox" data-automation="pay-info-table-row-payItemSelected-content" type="checkbox"
                          id="{{ 'select-payItem-' + payItems.id }}" [checked]="isPayItemSelected(payItems)"
                          (change)="selectPayItem(payItems, $event.target.checked)" />
                        <div class="pay-item-payment-type-container">
                          <span data-automation="pay-info-table-row-paymentType-content"
                            (mouseenter)="payItemPaymentType.present($event.target)"
                            (mouseleave)="payItemPaymentType.dismiss()">
                              {{getPaymentTypeTextKey(payItems.payItem.paymentType) | translate | truncate:15}}
                          </span>
                          <br/>
                          <span data-automation="pay-info-table-row-paymentType-pay-item-index" class="pay-item-index"
                            [hidden]="!payHasMultipleItems(payItems.pay) || payItems.payItemSequenceCount === payItems.pay.payItems.length">
                            {{ 'EMPLOYEE_PAYS.PAY_ITEM_INDEX_INFO' | translate:{ index: (payItems.payItemIndex + 1), count:
                            (payItems.pay.payItems.length) } }}
                          </span>
                        </div>
                      </label>
                    </div>
                    <ukg-popover #payItemPaymentType position="top">{{getPaymentTypeTextKey(payItems.payItem.paymentType) | translate}}</ukg-popover>
                  </td>
                  <td data-automation="pay-info-table-row-payItemAmount">
                    <span data-automation="pay-info-table-row-payItemAmount-content"
                      [hidden]="!showPayItems(payItems.pay)"
                      (mouseenter)="payItemAmount.present($event.target)"
                      (mouseleave)="payItemAmount.dismiss()" class="nowrap">
                        {{payItems?.payItem.amount | ulticurrency:'1.02':undefined:true}}
                    </span>
                    <ukg-popover #payItemAmount position="top">{{payItems.payItem.amount | ulticurrency:'1.02':undefined:true}}</ukg-popover>
                  </td>
                  <td data-automation="pay-info-table-row-payItemNumber">
                    <div data-automation="pay-info-table-row-payItemNumber-content"
                      (mouseenter)="payItemDocumentNumber.present($event.target)"
                      (mouseleave)="payItemDocumentNumber.dismiss()" 
                      class="nowrap">
                        {{payItems?.pay.documentNumber}}
                    </div>
                    <ukg-popover #payItemDocumentNumber position="top">{{payItems?.pay.documentNumber}}</ukg-popover>
                    <span *ngIf="payItems.payItem.maskedAccountNumber"
                      data-automation="pay-info-table-row-payItemNumber-content"
                      (mouseenter)="payItemMaskedAccountNumber.present($event.target)"
                      (mouseleave)="payItemMaskedAccountNumber.dismiss()">
                        {{payItems?.payItem.maskedAccountNumber}}
                    </span>
                    <ukg-popover #payItemMaskedAccountNumber position="top">{{payItems?.payItem.maskedAccountNumber}}</ukg-popover>
                  </td>
                  <td data-automation="pay-info-table-row-statusText"
                    [ngClass]="{ 'text-danger': isStatusError(payItems.payItem.lastKnownStatus), 'text-warning': isStatusWarning(payItems.payItem.lastKnownStatus) }">
                    <div 
                      (mouseenter)="payItemStatus.present($event.target)"
                      (mouseleave)="payItemStatus.dismiss()"
                      data-automation="pay-info-table-row-statusText-content" placement="top"
                      triggers="mouseenter:mouseleave" class="result-content">
                      <ukg-icon class="danger-icon" name="status-disabled"  *ngIf="isStatusError(payItems.payItem.lastKnownStatus)"
                        data-automation="pay-info-table-row-statusText-error-icon">
                      </ukg-icon>
                      <ukg-icon class="warning-icon" name="warning" *ngIf="isStatusWarning(payItems.payItem.lastKnownStatus)"
                        data-automation="pay-info-table-row-statusText-warning-icon">
                      </ukg-icon>
                      {{getStatusTextKey(payItems.payItem.lastKnownStatus) | translate | truncate:30}}
                    </div>
                    <ukg-popover #payItemStatus position="top">{{getStatusDescriptionKey(payItems.payItem.lastKnownStatus) | translate}}</ukg-popover>
                  </td>
                  <td data-automation="pay-info-table-row-attachments">
                    <span *ngIf="showActionHistoryIcon && payItems.hasActionHistory" class="attachment-icon"
                      (click)="showActionHistory(payItems)">
                      <ukg-icon name="document" data-automation="pay-info-table-row-attachments-history-icon">
                      </ukg-icon>
                    </span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ukg-data-table>
        <ukg-paginator id="paginator" data-automation="paginator" (ukgPageChanged)="onPaginatorChanged($event)"
          [rowsPerPage]="initialrowsPerPage" [totalItems]="dataCount" [rowsOptions]="rowsOptions" translate>
        </ukg-paginator>
      </ukg-data-table-container>
    </div>
  </div>
</div>

<ukg-popover #itemNumberTooltip type="standard">
  <span>
    <b><span [innerHtml]="'EMPLOYEE_PAYS.COLUMN_ITEM_NUMBER' | translate"></span></b>
    <br>
    <p data-automation="column_item_number_tooltip_text" translate>
      EMPLOYEE_PAYS.COLUMN_ITEM_NUMBER_TOOLTIP
    </p>
  </span>
</ukg-popover>

<ukg-modal #actionConfirmationModal autoScroll data-automation="modal-action-confirmation">
  <div *ngIf="!loadingData; else content">
  </div>
  <ng-template #content>
    <div class="modal-display-header">
      <h3 *ngIf="actionConfirmationInfo.isStop" class="modal-title" translate>
        EMPLOYEE_PAYS.ACTION_POPUP_TITLE_STOP
      </h3>
      <h3 class="modal-title" *ngIf="actionConfirmationInfo.isCancelStop" translate>
        EMPLOYEE_PAYS.ACTION_POPUP_TITLE_CANCELSTOP</h3>
      <ukg-button parent-icon="close" class="modal-close-icon" type="text"
        [attr.aria-label]="'COMMON.BUTTON_CLOSE' | translate" (click)="actionConfirmationModal.dismiss()" icon-only>
      </ukg-button>
    </div>
    <div class="modal-display-body">
      <ssg-pay-info-action-confirmation [confirmationInfo]="actionConfirmationInfo"></ssg-pay-info-action-confirmation>
    </div>
    <div class="modal-display-footer">
      <ukg-button-group>
        <ukg-button emphasis="mid" (click)="actionConfirmationModal.dismiss()" translate>COMMON.BUTTON_CANCEL
        </ukg-button>
        <ukg-button (click)="onSubmit('stopPayment')" [disabled]="!actionConfirmationInfo.isValid"
          *ngIf="actionConfirmationInfo.isStop" data-automation="stopPayment-modal-submit-btn" translate>
          EMPLOYEE_PAYS.ACTION_POPUP_SUBMIT_STOP</ukg-button>
        <ukg-button (click)="onSubmit('cancelStopPayment')" [disabled]="!actionConfirmationInfo.isValid"
          *ngIf="actionConfirmationInfo.isCancelStop" data-automation="cancelStopPayment-modal-submit-btn" translate>
          EMPLOYEE_PAYS.ACTION_POPUP_SUBMIT_CANCELSTOP
        </ukg-button>
      </ukg-button-group>
    </div>
  </ng-template>
</ukg-modal>

<ukg-modal #actionResultsModal autoScroll data-automation="modal-action-results">
  <div *ngIf="!actionResultLoaded; else actionResults">
  </div>
  <ng-template #actionResults>
    <div class="modal-display-header">
      <h3 class="modal-title" id="confirmation-title" translate>EMPLOYEE_PAYS.ACTION_CONFIRMATION_POPUP_TITLE</h3>
      <ukg-button (click)="actionResultsModal.dismiss()" parent-icon="close" class="modal-close-icon" type="text"
        [attr.aria-label]="'COMMON.BUTTON_CLOSE' | translate" icon-only>
      </ukg-button>
    </div>
    <div class="modal-display-body">
      <ssg-pay-info-action-results [resultsInfo]="actionResultsInfo"></ssg-pay-info-action-results>
    </div>
    <div class="modal-display-footer">
      <ukg-button-group>
        <ukg-button emphasis="mid" (click)="exportActionResults()" translate>
          COMMON.BUTTON_EXPORT
        </ukg-button>
        <ukg-button (click)="actionResultsModal.dismiss()" translate>
          COMMON.BUTTON_DONE
        </ukg-button>
      </ukg-button-group>
    </div>
  </ng-template>
</ukg-modal>

<ukg-modal #actionHistoryModal autoScroll data-automation="modal-action-history">
  <div *ngIf="!actionHistoryLoaded; else actionHistory">
  </div>
  <ng-template #actionHistory>
    <div class="modal-display-header">
      <h3 class="modal-title" translate>EMPLOYEE_PAYS.PAY_HISTORY_TITLE</h3>
      <ukg-button (click)="actionHistoryModal.dismiss()" parent-icon="close" class="modal-close-icon" type="text"
        [attr.aria-label]="'COMMON.BUTTON_CLOSE' | translate" icon-only>
      </ukg-button>
    </div>
    <div class="modal-display-body">
      <div class="wrap-container flex-row flex-space-between-center">
        <div class="flex-column">
          <span data-automation="action_history_modal_employee_name"><strong>
              {{ selectedActionHistories[0].employeeName}}
            </strong></span>
          <span class="text-muted" data-automation="pay_history_modal_employee_number">
            {{ selectedActionHistories[0].employeeNumber }}
          </span>
        </div>
        <div class="flex-column">
          <span data-automation="pay_history_modal_pay_date_label"><strong
              translate>EMPLOYEE_PAYS.COLUMN_PAY_DATE</strong></span>
          <span class="text-muted" data-automation="pay_history_modal_pay_date">
            {{ (selectedActionHistories[0].payUtcDate | ultishortdate: 'L') }}
          </span>
        </div>
        <div class="flex-column">
          <span data-automation="pay_history_modal_net_amount_label"><strong
              translate>EMPLOYEE_PAYS.COLUMN_NET_AMOUNT</strong></span>
          <span class="text-muted" data-automation="pay_history_modal_net_amount">
            {{ (selectedActionHistories[0].amount | ulticurrency:'1.02':undefined:true) }}
          </span>
        </div>
      </div>
      <div class="flex-column">
        <ukg-input-container class="history-container">
          <div *ngFor="let actionHistory of selectedActionHistories; let i = index">
            <div *ngIf="actionHistory.bankReasonCode"><small
                [innerHtml]="(actionHistory.isUndo ? 'EMPLOYEE_PAYS.PAY_HISTORY_UNDO_ACTION_DESCRIPTION' : 'EMPLOYEE_PAYS.PAY_HISTORY_ACTION_DESCRIPTION') | translate: translateActionHistory(actionHistory)"></small>
            </div>
            <div *ngIf="!actionHistory.bankReasonCode"><small
                [innerHtml]="(actionHistory.isUndo ? 'EMPLOYEE_PAYS.PAY_HISTORY_UNDO_ACTION_NO_REASON_DESCRIPTION' : 'EMPLOYEE_PAYS.PAY_HISTORY_ACTION_NO_REASON_DESCRIPTION') | translate: translateActionHistory(actionHistory)"></small>
            </div>
            <div><small>{{ 'EMPLOYEE_PAYS.PAY_HISTORY_COMMENT' | translate: {comment : actionHistory.text} }}</small>
            </div>
            <div><small>{{ actionHistory.actionUtcDateTime | ultishortdate:'LLL'}}</small></div>
            <hr *ngIf="selectedActionHistories.length > i+1" class="action-history-divider" />
          </div>
        </ukg-input-container>
      </div>
    </div>
    <div class="modal-display-footer">
      <ukg-button (click)="actionHistoryModal.dismiss()" translate>COMMON.BUTTON_CLOSE</ukg-button>
    </div>
  </ng-template>
</ukg-modal>